import { useFetchPodcastMetadata } from 'client/hooks/podcast/usePodcastMetadata';
import { useFeatureFlagsCtx } from 'client/contexts/FeatureFlags';
import { getIsSaiOrVodcast } from 'client/modules/FeatureFlags';
import { getQueryStatus } from '../utils/getQueryStatus';

/**
 * studio creators are techically SAI users on the backend. this give them
 * the abilty to fetch and update cue points for example.
 *
 * but for the waveform ad experience on web, we do not want them to see the
 * existing experience that accounts like JRE will see.
 *
 * so if a user is a Studio Creator, exclude them in the SAI or Vodcast
 * feature flag experience
 */
export function useIsSaiOrVodcast() {
  const {
    data: stationMetadata,
    status: statusFetchPodcastMetadata,
  } = useFetchPodcastMetadata();
  const {
    state,
    state: { status: statusFeatureFlags },
  } = useFeatureFlagsCtx();

  const status = getQueryStatus([
    statusFeatureFlags,
    statusFetchPodcastMetadata,
  ]);
  switch (status) {
    case 'success': {
      if (stationMetadata?.isStudioCreator) return false;
      return getIsSaiOrVodcast(state.featureFlags);
    }
    case 'error':
    case 'idle':
    case 'loading':
    default:
      return undefined;
  }
}
